import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { computed } from "mobx";
import { MIN_WIDTH_BREAKPOINTS } from "./media";
import { ObservableWindow } from "./ObservableWindow";
export var Viewport = /*#__PURE__*/ function() {
    "use strict";
    function Viewport() {
        var _this = this;
        _class_call_check(this, Viewport);
        this.minWidthBreakpoints = {
            tablet: MIN_WIDTH_BREAKPOINTS.TABLET,
            desktop: MIN_WIDTH_BREAKPOINTS.DESKTOP,
            xlarge: MIN_WIDTH_BREAKPOINTS.XLARGE,
            xxlarge: MIN_WIDTH_BREAKPOINTS.XXLARGE
        };
        this.observableWindow = new ObservableWindow();
        this.initialize = function() {
            _this.observableWindow.initialize();
        };
        this.responsivelyReturnValue = function(param) {
            var mobileAndAbove = param.mobileAndAbove, tabletAndAbove = param.tabletAndAbove, desktopAndAbove = param.desktopAndAbove, xLargeAndAbove = param.xLargeAndAbove, xxLargeDesktop = param.xxLargeDesktop;
            if (_this.isXXLargeDesktop) {
                var _ref, _ref1, _ref2;
                return (_ref2 = (_ref1 = (_ref = xxLargeDesktop !== null && xxLargeDesktop !== void 0 ? xxLargeDesktop : xLargeAndAbove) !== null && _ref !== void 0 ? _ref : desktopAndAbove) !== null && _ref1 !== void 0 ? _ref1 : tabletAndAbove) !== null && _ref2 !== void 0 ? _ref2 : mobileAndAbove;
            }
            if (_this.isXLargeAndAbove) {
                var _ref3, _ref4;
                return (_ref4 = (_ref3 = xLargeAndAbove !== null && xLargeAndAbove !== void 0 ? xLargeAndAbove : desktopAndAbove) !== null && _ref3 !== void 0 ? _ref3 : tabletAndAbove) !== null && _ref4 !== void 0 ? _ref4 : mobileAndAbove;
            }
            if (_this.isDesktopAndAbove) {
                var _ref5;
                return (_ref5 = desktopAndAbove !== null && desktopAndAbove !== void 0 ? desktopAndAbove : tabletAndAbove) !== null && _ref5 !== void 0 ? _ref5 : mobileAndAbove;
            }
            if (_this.isTabletAndAbove) {
                return tabletAndAbove !== null && tabletAndAbove !== void 0 ? tabletAndAbove : mobileAndAbove;
            }
            return mobileAndAbove;
        };
        makeObservable(this);
    }
    _create_class(Viewport, [
        {
            key: "width",
            get: function get() {
                return this.observableWindow.width;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.observableWindow.height;
            }
        },
        {
            key: "scrollY",
            get: function get() {
                return this.observableWindow.scrollY;
            }
        },
        {
            key: "lastScrolledDirection",
            get: function get() {
                return this.observableWindow.lastScrolledDirection;
            }
        },
        {
            key: "isTouchDevice",
            get: function get() {
                return this.observableWindow.isTouchDevice;
            }
        },
        {
            key: "isWindowFocused",
            get: function get() {
                return this.observableWindow.isWindowFocused;
            }
        },
        {
            key: "isOnline",
            get: function get() {
                return this.observableWindow.isOnline;
            }
        },
        {
            key: "isMobile",
            get: function get() {
                return this.width < this.minWidthBreakpoints.tablet;
            }
        },
        {
            key: "isTablet",
            get: function get() {
                return this.minWidthBreakpoints.tablet <= this.width && this.width < this.minWidthBreakpoints.desktop;
            }
        },
        {
            key: "isDesktop",
            get: function get() {
                return this.minWidthBreakpoints.desktop <= this.width && this.width < this.minWidthBreakpoints.xlarge;
            }
        },
        {
            key: "isXLargeDesktop",
            get: function get() {
                var _this_minWidthBreakpoints_xxlarge;
                return this.minWidthBreakpoints.xlarge <= this.width && this.width < ((_this_minWidthBreakpoints_xxlarge = this.minWidthBreakpoints.xxlarge) !== null && _this_minWidthBreakpoints_xxlarge !== void 0 ? _this_minWidthBreakpoints_xxlarge : MIN_WIDTH_BREAKPOINTS.XXLARGE);
            }
        },
        {
            key: "isXXLargeDesktop",
            get: function get() {
                var _this_minWidthBreakpoints_xxlarge;
                return this.width >= ((_this_minWidthBreakpoints_xxlarge = this.minWidthBreakpoints.xxlarge) !== null && _this_minWidthBreakpoints_xxlarge !== void 0 ? _this_minWidthBreakpoints_xxlarge : MIN_WIDTH_BREAKPOINTS.XXLARGE);
            }
        },
        {
            key: "isTabletAndAbove",
            get: function get() {
                return this.width >= this.minWidthBreakpoints.tablet;
            }
        },
        {
            key: "isDesktopAndAbove",
            get: function get() {
                return this.width >= this.minWidthBreakpoints.desktop;
            }
        },
        {
            key: "isXLargeAndAbove",
            get: function get() {
                return this.width >= this.minWidthBreakpoints.xlarge;
            }
        },
        {
            key: "isTabletAndBelow",
            get: function get() {
                return !this.isDesktopAndAbove;
            }
        }
    ]);
    return Viewport;
}();
__decorate([
    computed
], Viewport.prototype, "isMobile", null);
__decorate([
    computed
], Viewport.prototype, "isTablet", null);
__decorate([
    computed
], Viewport.prototype, "isDesktop", null);
__decorate([
    computed
], Viewport.prototype, "isXLargeDesktop", null);
__decorate([
    computed
], Viewport.prototype, "isXXLargeDesktop", null);
__decorate([
    computed
], Viewport.prototype, "isTabletAndAbove", null);
__decorate([
    computed
], Viewport.prototype, "isDesktopAndAbove", null);
__decorate([
    computed
], Viewport.prototype, "isXLargeAndAbove", null);
__decorate([
    computed
], Viewport.prototype, "isTabletAndBelow", null);
var defaultViewport;
(function(Viewport) {
    /**
     * @deprecated replace with useViewport
     * @trackfunction
     */ Viewport.getDefault = function() {
        if (!defaultViewport) {
            defaultViewport = new Viewport();
            defaultViewport.initialize();
        }
        return defaultViewport;
    };
})(Viewport || (Viewport = {}));
export default Viewport;
